import {
  authVuexStore,
  bookinginsightsVuexStore,
  creditcodeVuexStore,
  experimentsVuexStore,
  internalreviewsVuexStore,
  itemcategoryVuexStore,
  itemsearchVuexStore,
  itemvehicleVuexStore,
  listingVuexStore,
  locationVuexStore,
  pagesVuexStore,
  partnerVuexStore,
  phonenumberVuexStore,
  propertyVuexStore 
} from "#imports"
const VuexStore = {
  modules: {
      'auth': {
        ...authVuexStore.default ?? authVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'booking-insights': {
        ...bookinginsightsVuexStore.default ?? bookinginsightsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'credit-code': {
        ...creditcodeVuexStore.default ?? creditcodeVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'experiments': {
        ...experimentsVuexStore.default ?? experimentsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'internal-reviews': {
        ...internalreviewsVuexStore.default ?? internalreviewsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'item-category': {
        ...itemcategoryVuexStore.default ?? itemcategoryVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'item-search': {
        ...itemsearchVuexStore.default ?? itemsearchVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'item-vehicle': {
        ...itemvehicleVuexStore.default ?? itemvehicleVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'listing': {
        ...listingVuexStore.default ?? listingVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'location': {
        ...locationVuexStore.default ?? locationVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'pages': {
        ...pagesVuexStore.default ?? pagesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'partner': {
        ...partnerVuexStore.default ?? partnerVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'phone-number': {
        ...phonenumberVuexStore.default ?? phonenumberVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'property': {
        ...propertyVuexStore.default ?? propertyVuexStore,
        namespaced: true,
        modules: {},
      }
    }, 
  }
export default VuexStore